"use strict";

exports.__esModule = true;
exports.pieChartPositioningOnLayoutOptions = void 0;
var _constants = require("../../constants");
var BIG_RADIUS = 75;
var MIDDLE_RADIUS = 35;
var SMALL_RADIUS = 25;
var pieChartPositioningOnLayoutOptions = exports.pieChartPositioningOnLayoutOptions = function pieChartPositioningOnLayoutOptions(layout, index) {
  switch (layout) {
    case _constants.LAYOUT_TWO_COLUMNS:
      return {
        center: [["26%", "50%"], ["74%", "50%"]][index],
        radius: BIG_RADIUS
      };
    case _constants.LAYOUT_TWO_ROWS:
      return {
        center: [["50%", "30.75%"], ["50%", "69.25%"]][index],
        radius: MIDDLE_RADIUS
      };
    case _constants.LAYOUT_THREE_COLUMNS:
      return {
        center: [["17.8%", "50%"], ["50%", "50%"], ["82.2%", "50%"]][index],
        radius: BIG_RADIUS
      };
    case _constants.LAYOUT_THREE_ROWS:
      return {
        center: [["50%", "24.5%"], ["50%", "50%"], ["50%", "75.5%"]][index],
        radius: SMALL_RADIUS
      };
    case _constants.LAYOUT_BOTTOM_ROW_TWO_TILES:
      return {
        center: [["50%", "30.75%"], ["26%", "69.25%"], ["74%", "69.25%"]][index],
        radius: MIDDLE_RADIUS
      };
    case _constants.LAYOUT_LEFT_COLUMN_TWO_TILES:
      return {
        center: [["26%", "30.75%"], ["26%", "69.25%"], ["74%", "50%"]][index],
        radius: [MIDDLE_RADIUS, MIDDLE_RADIUS, BIG_RADIUS][index]
      };
    case _constants.LAYOUT_RIGHT_COLUMN_TWO_TILES:
      return {
        center: [["26%", "50%"], ["74%", "30.75%"], ["74%", "69.25%"]][index],
        radius: [BIG_RADIUS, MIDDLE_RADIUS, MIDDLE_RADIUS][index]
      };
    case _constants.LAYOUT_TOP_ROW_TWO_TILES:
      return {
        center: [["26%", "30.75%"], ["74%", "30.75%"], ["50%", "69.25%"]][index],
        radius: MIDDLE_RADIUS
      };
    default:
      return {
        center: ["50%", "50%"],
        radius: BIG_RADIUS
      };
  }
};